
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contests/story-sapphire",
      function () {
        return require("private-next-pages/contests/story-sapphire.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contests/story-sapphire"])
      });
    }
  